import { Flex } from '@chakra-ui/react';

import { COMMON_WEB_PATH } from '@/constant';

const CommonConfirmButton = (props) => {
  return (
    <Flex
      as="button"
      w="165px"
      h="60px"
      bgImage={`url('${COMMON_WEB_PATH}/blue-layout/modal/confirm_button.png')`}
      bgPosition="center"
      bgRepeat="no-repeat"
      bgSize="100% 100%"
      cursor="pointer"
      justifyContent="center"
      alignItems="center"
      _hover={{ filter: 'brightness(1.1)' }}
      {...props}
    ></Flex>
  );
};

export default CommonConfirmButton;
